const Colors = {
  red: '#B00020',
  green: '#007e33',
};

export default Colors;
